module.exports = __webpack_public_path__ + "static/img/美的风尊二代pro空调.1b8adc35.png";